// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"822ea6b6","703":"7d60a75b","787":"70079b53"}[chunkId] + ".chunk.js";
};